import type { AnalyticsWidgetStats, FunnelItem, WidgetEventType } from '@shared/api';

export const WIDGET_EVENT_ORDER: WidgetEventType[] = [
  'WIDGET_SHOWN',
  'PREVIEW_OPEN',
  'CHAT_OPEN',
  'FIRST_MESSAGE_SENT',
  'AUTH_FORM_SHOWN',
  'AUTH_FORM_SUBMIT',
];

export const WIDGET_EVENT_COLORS: Record<WidgetEventType, string> = {
  WIDGET_SHOWN: '#7C4DFF',
  PREVIEW_OPEN: '#234EEE',
  CHAT_OPEN: '#00A6A6',
  FIRST_MESSAGE_SENT: '#F59E0B',
  AUTH_FORM_SHOWN: '#E84A8A',
  AUTH_FORM_SUBMIT: '#0EA900',
};

export type WidgetChartPoint = {
  date: string;
} & Partial<Record<WidgetEventType, number>>;

export const normalizeFunnelItems = (items: FunnelItem[]): FunnelItem[] => {
  const itemsByEvent = new Map(items.map((item) => [item.event_type, item]));

  return WIDGET_EVENT_ORDER.map(
    (eventType) =>
      itemsByEvent.get(eventType) ?? {
        event_type: eventType,
        value: 0,
        conversion_from_previous: 0,
        conversion_from_shown: 0,
      },
  );
};

export const mapWidgetSeriesToChartData = (
  dynamics: AnalyticsWidgetStats['dynamics'] | undefined,
): WidgetChartPoint[] => {
  if (!dynamics) return [];

  const pointsByDate = new Map<string, WidgetChartPoint>();

  dynamics.series.forEach((series) => {
    series.points.forEach((point) => {
      const chartPoint = pointsByDate.get(point.date) ?? { date: point.date };
      chartPoint[series.event_type] = point.value;
      pointsByDate.set(point.date, chartPoint);
    });
  });

  return Array.from(pointsByDate.values()).sort((left, right) =>
    left.date.localeCompare(right.date),
  );
};

export const formatConversion = (value: number) => {
  if (!Number.isFinite(value)) return '0%';
  return `${new Intl.NumberFormat('en', { maximumFractionDigits: 1 }).format(value)}%`;
};
